import { useState, useEffect } from 'react';
import { getFeaturedPreload } from '../lib/preload';
import { prefetchFeatured } from '../lib/prefetch';

const API = window.location.origin;

export function useFeaturedPoem() {
  const [featured, setFeatured]         = useState(null);
  const [error, setError]               = useState(false);
  const [regenerating, setRegenerating] = useState(false);
  const [visible, setVisible]           = useState(true);

  useEffect(() => {
    const ctrl = new AbortController();
    const preload = getFeaturedPreload();
    const request = preload
      ? preload.then(data => {
          if (!data) throw new Error('preload-empty');
          return data;
        })
      : fetch(`${API}/api/poems/browse?mode=featured`, { signal: ctrl.signal })
          .then(r => { if (!r.ok) throw new Error('non-ok'); return r.json(); });

    request
      .then(data => {
        setError(false);
        setFeatured(data);
        if (data?.poemId) {
          prefetchFeatured(data.poemId);
        }
      })
      .catch(err => {
        if (err.name !== 'AbortError') setError(true);
      });
    return () => ctrl.abort();
  }, []);

  async function regenerate() {
    if (regenerating) return;
    setRegenerating(true);
    setVisible(false);
    try {
      const exclude = featured?.poemId ?? '';
      const r = await fetch(`${API}/api/poems/random?exclude=${encodeURIComponent(exclude)}`);
      if (!r.ok) throw new Error('non-ok');
      setFeatured(await r.json());
      setError(false);
    } catch {
      setError(true);
    } finally {
      setRegenerating(false);
      setVisible(true);
    }
  }

  return { featured, error, regenerating, visible, regenerate };
}
